import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import * as backInter from 'app/auth/auth-data.model';
import { DATOS_API } from 'app/auth/auth.datos';
/// SERVICIO DE AUTENTICACION
import { AuthService } from 'app/auth/auth.service';

import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ForAllService {

  idEmpresa: string;
  idUsuario: string;
  infoUsuario: any;
  idInstituto: string;

  private mensajeOrigen = new BehaviorSubject('');
  mensajeActual = this.mensajeOrigen.asObservable();

  constructor(
    private http:HttpClient,
    private authService:AuthService
  ) {
    this.obtienInfo();
  }

  obtienInfo()
  {
    this.idUsuario = this.authService.getIdUsuario();
    this.idInstituto = this.authService.getInstituto();
    let infoUsu: backInter.infoUsuario = this.authService.getInfoUsuario();
    // console.log(infoUsu);
    this.idEmpresa = infoUsu.empresaId;
    this.infoUsuario = this.authService.getInfoUsuario();
  }

  getInstituto(){
    this.obtienInfo();
    return this.idInstituto;
  }

  getInfoUsuario(){
    return this.infoUsuario;
  }

  getParams(datos) {
    this.obtienInfo();
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.forAll.postStatements + this.idEmpresa, datos);
  }

  getPracticas(datos) {
    this.obtienInfo();
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.forAll.postForallGet + this.idEmpresa, datos);
  }

  guardaDatosPractica(datos){
    this.obtienInfo();
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.forAll.postGuardar + this.idEmpresa, datos);
  }

  getIdiomasEncuesta(datos) {
    this.obtienInfo();
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.forAll.getLanguajesListSelected + this.idEmpresa, datos);
  }

  guardaTraduccion(datos) {
    this.obtienInfo();
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.forAll.insertTranslate + this.idEmpresa, datos);
  }

  getIdiomasPreview(datos) {
    this.obtienInfo();
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.forAll.getLanguajesListNon3 + this.idEmpresa, datos);
  }

}
